// @flow

import type { FormError } from '../store/reducers/auth';

type Input = {
  email: string
}

type Output = FormError[];

const EMAILREGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line max-len

const validate = (hash: Input): Output => {
  const rules = {
    email: (input) => {
      if (input.length < 1) {
        return 'email_presence';
      }
      if (input.length < 5) {
        return 'email_length';
      }
      if (EMAILREGEX.test(String(input).toLowerCase())) {
        return null;
      }
      return 'email_validity';
    }
  };
  return Object.keys(hash).reduce((memo, key) => {
    const error = rules[key](hash[key]);
    if (error) {
      return memo.concat({
        field: key,
        code: error
      });
    }
    return memo;
  }, []);
};

export default validate;


// WEBPACK FOOTER //
// ./src/validators/forgot-password.js